<template>
    <div class="section">
        <div class="section__container">
            <div class="section__right">
                <div class="section__form">
                    <div class="section__header">Recover Password</div>
                    <div v-if="emailSent">
                        <p class="section__message">A link has been sent to your email address kindly click the link to complete the password reset.</p>
                        <div class="form__footer">
                            <p>
                                <router-link to="/login">Go back to sign in</router-link>
                            </p>
                        </div>
                    </div>
                    <div v-else>
                        <div class="section__caption">Please enter your email address. We will send you an email to reset your password.</div>
                        <form @submit.prevent="resetPassword">
                            <div class="form__item">
                                <label class="form__label" for>Email Address</label>
                                <input class="form__input" required type="email" v-model="emailAddress.value" />
                                <span class="attention" v-if="emailAddress.empty">Field can't be empty</span>
                            </div>
                            <br />
                            <button class="btn btn--primary btn--block" type="submit">Submit</button>
                        </form>
                        <div class="form__footer">
                            <p>
                                <router-link to="/login">Go back to sign in</router-link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: "Reset Password"
    },
    data() {
        return {
            emailAddress: {
                value: "",
                empty: false
            },
            disabled: false,
            emailSent: false
        };
    },

    created() {
        window.localStorage.clear();
    },

    methods: {
        resetPassword() {
            this.emailAddress.empty = false;
            if (this.emailAddress.value !== "") {
                this.disabled = true;
                let requestObject = {
                    email: this.emailAddress.value.trim()
                };
                this.$http
                    .post("dashboard/merchants/password_reset_init/admin", requestObject)
                    .then(response => {
                        this.disabled = false;
                        this.emailSent = true;
                        this.$notify({
                            group: "notifications-default",
                            type: "success text-white",
                            title: "Success",
                            text: response.body.message
                        });
                    })
                    .catch(error => {
                        this.disabled = false;
                        this.$notify({
                            group: "notifications-default",
                            type: "error text-white",
                            title: "Error",
                            text: error.body.message
                        });
                    });
            } else {
                this.emailAddress.empty = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.section {
    background-image: url("../../../public/img/background.svg");
    background-repeat: no-repeat;
    background-position: right center;
    background-size: contain;
    padding-top: 50px;
    @include media(768px) {
        padding-top: 0px;
        height: 100vh;
        display: flex;
        align-items: center;
    }
    &__container {
        @include container;
        display: flex;
        justify-content: center;
    }

    &__right {
        background-color: #ffffff;
        border: 1px solid rgba(97, 110, 124, 0.2);
        box-sizing: border-box;
        box-shadow: 0px 8px 14px rgba(0, 0, 0, 0.05);
        border-radius: 6px;
        padding: 40px 25px 0;
        @include media(768px) {
            width: 448px;
            padding: 40px 64px 0;
        }
    }

    &__left {
        width: 50%;
        margin-right: 168px;
    }

    &__header {
        font-size: 24px;
        margin-bottom: 22px;
        font-weight: 400;
        @include media(768px) {
            font-size: 32px;
        }
    }

    &__caption {
        font-size: 14px;
        line-height: 24px;
        color: #2D3044;
        margin-bottom: 22px;
    }

    &__message {
        font-size: 14px;
        line-height: 24px;
        color: #2D3044;
        margin-bottom: 22px;
        padding: 24px;
    }
}
</style>